export default __webpack_public_path__ + "static/joinCode-b3e3683cca026b37fadf5d0e5aad6dcd.jpg";